import { OrderHoldStatus } from '@invenco/common-domain/enums';
import type { OrderDTO } from '@invenco/sales-interface/interfaces';

import { Alert, AlertDescription, AlertTitle } from '@/components/core/alert';

import { getHoldDescription, getHoldTitle } from './order-holds';

type Props = {
  order: OrderDTO | undefined;
};

export function OrderHoldAlert({ order }: Props) {
  const activeHolds = order?.orderHolds?.filter((hold) => hold.status === OrderHoldStatus.HOLD);

  if (!order || !activeHolds?.length) return null;

  return (
    <Alert variant="error">
      <AlertTitle>
        {activeHolds.length === 1 ? getHoldTitle(activeHolds[0], 'applied') : 'On hold'}
      </AlertTitle>
      <AlertDescription>
        {activeHolds.length === 1 ? (
          getHoldDescription(order, activeHolds[0])
        ) : (
          <ul className="list-disc pl-4">
            {activeHolds.map((hold) => (
              <li key={hold.id}>{getHoldDescription(order, hold)}</li>
            ))}
          </ul>
        )}
      </AlertDescription>
    </Alert>
  );
}
